/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const Accordion = {

	$domAcc: $('.js-faq-acc-btn'),
	classActive: 'is-active',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domAcc.on('click', this.showAcc);
	},

	showAcc: function() {
		if ($(this).hasClass(Accordion.classActive)) {
			$(this).removeClass(Accordion.classActive);
		} else {
			Accordion.$domAcc.removeClass(Accordion.classActive);
			$(this).addClass(Accordion.classActive);
		}
	}
};

export default Accordion;
